import { useState } from "react";
import { useContextContrato } from "src/Contexts/Lancamentos/Contrato/ContratosContext";
import { valueDefaultInputContratos } from "src/Contexts/Lancamentos/Contrato/valuesDefaultInputsContratos/ValueDefaultInputContratos";
import {
  DropZoneCore,
  IListPDF,
} from "src/Pages/components/DropZoneCore/DropZoneCore";
import { FormatDateUS, GetDateUSSemValue } from "src/shared/Utils/FormatDateBR";
import { FormatMoney } from "src/shared/Utils/FormatMoney";
import { formatString } from "@format-string/core";
import axios from "axios";
import { cpfOurCnpj } from "src/shared/Utils/MaskCpfCnpj";
import { FormatRG } from "src/shared/Utils/FormatRG/FormatRG";
import { handleFormatCep } from "src/shared/Utils/FormatCEP";
import {
  alpha,
  Box,
  CircularProgress,
  Divider,
  Tooltip,
  useMediaQuery,
} from "@mui/material";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import { ButtonCore } from "src/Pages/components/ButtonCore/ButtonCore";
// import { InfoOutlinedIcon } from "src/Pages/components/Icons/Icons";
import { useAppThemeContext } from "src/Contexts/ThemeContextConfig";
import { useLayoutMainContext } from "src/Contexts/MainLayoutContext";

export const UploadWithIAContract = () => {
  const { setValuesInputsContrato } = useContextContrato();
  const { themeName } = useAppThemeContext();

  const [loading, setLoading] = useState(false);
  const isMobile = useMediaQuery("(max-width: 600px)");

  const handleUpdateAvatar = (files: IListPDF[]) => {
    const formData = new FormData();
    const { handleGetAlert } = useLayoutMainContext();

    const blob = new Blob([files[0].pdf], { type: files[0].type });
    formData.append("file", blob, files[0].name);

    const objGenero = {
      feminino: "FEMALE",
      masculino: "MALE",
      outro: "OTHER",
      nao_informado: "NONE",
    } as const;

    const objEstadoCivil = {
      solteiro: "SINGLE",
      casado: "MARRIED",
      separado: "SEPARATE",
      divorciado: "DIVORCED",
      viuvo: "WIDOWER",
      nao_informado: "NONE",
    } as const;

    setLoading(true);

    return axios
      .post(
        `https://ia-leitura-pdf-contrato-production.up.railway.app`,
        formData
      )
      .then(({ data: { data } }) => {
        setValuesInputsContrato({
          ...valueDefaultInputContratos,

          subscriptionDate: FormatDateUS(
            data.contrato?.data_assinatura?.trim() ?? `${GetDateUSSemValue()}`
          ),

          proposalCode: data.contrato?.proposta,

          contractType: data.contrato?.tipo_pessoa ?? "PF",

          holder: data.titular?.nome_titular?.trim() ?? "",
          motherName: data.titular?.nome_mae_titular?.trim() ?? "",

          maritalStatus:
            objEstadoCivil[
              data.titular?.estado_civil_titular
                ?.trim()
                .toLowerCase() as keyof typeof objEstadoCivil
            ],

          gender:
            objGenero[
              (data.titular?.genero_titular
                ?.trim()
                .toLowerCase() as keyof typeof objGenero) ?? "nao_informado"
            ],
          rg: FormatRG(data.titular?.rg_titular),

          cpf: cpfOurCnpj({
            text: data.titular?.cpf_titular,
            type: data.contrato?.tipo_pessoa === "PF" ? "cpf" : "cnpj",
          }),

          // birthDate: handleVerifyDateIsValidLib(
          //   data.titular?.data_nascimento_responsavel?.trim()
          // )
          //   ? FormatDateUS(
          //       data.titular?.data_nascimento_responsavel?.trim() ?? ""
          //     )
          //   : ``,

          companyName: data.titular?.nome_titular?.trim() ?? "",
          cnpj: cpfOurCnpj({
            text: data.titular?.cpf_titular,
            type: data.contrato?.tipo_pessoa === "PF" ? "cpf" : "cnpj",
          }),

          email: data?.endereco_contato?.email,
          phone1:
            formatString({
              type: "phone",
              value: data?.endereco_contato?.telefone_1 ?? "",
            }) || "",
          phone2:
            formatString({
              type: "phone",
              value: data?.endereco_contato?.telefone_2 ?? "",
            }) || "",

          postalCode: handleFormatCep(
            data?.endereco_contato?.cep?.trim() ?? ""
          ),
          number: data?.endereco_contato?.numero?.trim() ?? "",
          city: data?.endereco_contato?.cidade?.trim() ?? "",
          neighborhood: data?.endereco_contato?.bairro?.trim() ?? "",
          state: data?.endereco_contato?.uf?.trim() ?? "",
          street: data?.endereco_contato?.endereco?.trim() ?? "",
          complement: data?.endereco_contato?.complemento?.trim() ?? "",

          startDate:
            FormatDateUS(data?.dados?.data_vigencia?.trim() ?? "") ??
            `${GetDateUSSemValue()}`,
          issuanceDate:
            FormatDateUS(data?.dados?.data_emissao?.trim() ?? "") ??
            `${GetDateUSSemValue()}`,
          expirationDate:
            FormatDateUS(data.dados?.data_vigencia?.trim() ?? "") ??
            `${GetDateUSSemValue()}`,

          monthlyPayment: FormatMoney(data.dados?.mensalidade),

          commissionGrade: "",
        });
      })
      .catch((error) => {
        handleGetAlert({ message: error.response.data.message });
      })
      .finally(() => setLoading(false));
  };

  return (
    <>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "12px",
          mb: "12px",
          justifyContent: "space-between",
          position: "relative",
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "160px",
            // right: "150px",
            right: "0px",
            height: "2px",
            background: (theme) =>
              `linear-gradient(90deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
            transform: "translateY(-50%)",
            zIndex: 0,
            mr: "4px",
          }}
        />
        <DropZoneCore
          onFilesChange={loading ? undefined : handleUpdateAvatar}
          multiple={false}
          accept={{ "application/pdf": [] }}
          disabled={loading}
          sxStyle={{ display: "inline-block", position: "relative", zIndex: 1 }}
        >
          <Tooltip title="Selecione uma proposta em PDF para importar dados automaticamente com IA">
            <ButtonCore
              sx={{
                position: "relative",
                zIndex: 1,
                fontWeight: "bold",
                fontSize: "12px",
                cursor: loading ? "default" : "pointer",
                color: (theme) => theme.palette.text.primary,
                borderRadius: "10px",
                padding: "10px 20px",
                background: themeName === "dark" ? "#2d2f36" : "#fff",
                "&::before": {
                  content: '""',
                  position: "absolute",
                  zIndex: -1,
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  borderRadius: "inherit",
                  padding: "2px",
                  background:
                    "linear-gradient(145deg, #00f57b, #00d9f5, #9c27b0, #f50057)",
                  WebkitMask:
                    "linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)",
                  WebkitMaskComposite: "xor",
                  maskComposite: "exclude",
                },
                "&:hover": {
                  background: (theme) =>
                    themeName === "dark"
                      ? "#3c3f49"
                      : alpha(theme.palette.background.paper, 0.9),
                },
              }}
              title={isMobile ? "Importar com IA" : "Importar dados com IA"}
              disabled={loading}
              endIcon={
                loading ? (
                  <CircularProgress size={14} />
                ) : (
                  <AutoAwesomeIcon style={{ fontSize: "16px" }} />
                )
              }
            />
          </Tooltip>
        </DropZoneCore>

        {/* <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            position: "relative",
            zIndex: 1,
          }}
        >
          <Typography sx={{ color: (theme) => theme.palette.text.primary }}>
            Créditos: 1 de 10
          </Typography>
          <Tooltip title="Você possui 10 créditos por mês para importar dados automaticamente com IA">
            <InfoOutlinedIcon
              sx={{
                fontSize: "16px",
                cursor: "pointer",
                color: (theme) => theme.palette.text.primary,
              }}
            />
          </Tooltip>
        </Box> */}
      </Box>
      <Divider sx={{ mb: "12px" }} />
    </>
  );
};
